import Popover from '@cloudscape-design/components/popover';
import Box from '@cloudscape-design/components/box';
import { humanizeArn, isArn } from '../utils/arnUtils';

interface ArnDisplayProps {
  value: string | undefined;
  fallback?: string;
}

/**
 * Displays a humanized ARN with a Popover showing the full ARN on click.
 * For non-ARN values, displays the value as-is without a Popover.
 */
export function ArnDisplay({ value, fallback = '-' }: ArnDisplayProps) {
  if (!value) {
    return <span>{fallback}</span>;
  }

  if (!isArn(value)) {
    return <span>{value}</span>;
  }

  return (
    <Popover
      dismissButton={false}
      position="top"
      size="large"
      triggerType="text"
      content={
        <Box color="text-body-secondary" fontSize="body-s">
          {value}
        </Box>
      }
    >
      {humanizeArn(value)}
    </Popover>
  );
}
